import React, { useEffect, useState } from 'react';
import { listTags, } from '../../actions/tagActions';
import { useSelector, useDispatch } from 'react-redux';
import Listing from '../Common/Listing/Listing';
import { FaPlus } from 'react-icons/fa'; // Importing the plus icon
import _ from "lodash"
import { getUserFromToken } from '../../utils/utility';

const ManageTags = (props) => {
    const listFormKey = "tags_list_form";

    const dispatch = useDispatch();
    const tagsState = useSelector((state) => state.tags);
    const { listing = {} } = tagsState;
    const { headers = [], data: listData = [], meta = {} } = listing;
    const [fetchingList, setFetchingList] = useState(true);

    const { userId = 'INVALID' } = getUserFromToken() || {};
    useEffect(() => {
        setFetchingList(true);
        dispatch(listTags({ enabled: true, deleted: false, type: `EQ_TAGS##${userId}` }, listFormKey));
    }, []);

    useEffect(() => {
        if (!_.isEmpty(listing)) {
            setFetchingList(false);
        }
    }, [listing]);

    const handleAdd = () => {
        window.open(`/tags/add`, "_blank", "noreferrer");
    }

    const actionsHandling = (action, rowData) => {
        const { id = '' } = rowData;
        switch (action.id) {
            case "edit": {
                window.open(`/tags/edit?id=` + id, "_blank", "noreferrer");
                break;
            }
            case "copy": {
                window.open(`/tags/copy?id=` + id, "_blank", "noreferrer");
                break;
            }
            default: alert('Yet to implement');
        }
    }

    return (
        <div style={{ position: 'relative', paddingBottom: '80px' }}> {/* Added padding-bottom */}
            {headers.length > 0 ?
                <Listing
                    headers={headers}
                    data={listData}
                    meta={meta}
                    actionsHandling={actionsHandling}
                    fetchingList={fetchingList}
                /> : ''}

            {/* Floating Add Button */}
            <div
                onClick={() => handleAdd()}
                style={{
                    position: 'fixed',
                    bottom: '20px',
                    right: '20px',
                    backgroundColor: 'green',
                    color: 'white',
                    borderRadius: '50%',
                    padding: '15px',
                    cursor: 'pointer',
                    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                    zIndex: 1000,
                }}
                title={'Add Tag'}
            >
                <FaPlus size={20} />
            </div>
        </div>
    );
}

export default ManageTags;
